const UserTypes = {
    ADD_PRODUCT : 'ADD_PRODUCT',
    CLEAR_PRODUCT: 'CLEAR_PRODUCT',
    REMOVE_PRODUCT: 'REMOVE_PRODUCT',
    GET_LOCATION: 'GET_LOCATION',
    DESTROY_PRODUCT: "DESTROY_PRODUCT"
}

export default UserTypes;